import React, { useEffect, useState } from 'react';
import './App.css';

function App() {
  const [data, setData] = useState({ stats: { positive: 0, negative: 0, utility: 0 }, tags: [], friction_point: "None" });

  useEffect(() => {
    const fetchData = () => {
      fetch('https://api.yourcommunity.forum/api/sentiment-summary')
        .then(res => res.json()).then(data => setData(data))
        .catch(err => console.error("Data Fetch Error:", err));
    };
    fetchData();
    const interval = setInterval(fetchData, 30000);
    return () => clearInterval(interval);
  }, []);

  const total = data.stats.positive + data.stats.negative;
  const health = total > 0 ? Math.round((data.stats.positive / total) * 100) : 0;

  return (
    <div className="App">
      <div className="sqs-header">
        <h1>The Forum Report</h1>
        <p>Community Sentiment</p>
        <div className="sqs-divider"></div>
      </div>

      <div className="sqs-status-card">
        <div className="sqs-health-info">
          <strong>Civic Health: {health}%</strong>
          <div className="sqs-bar-bg">
            <div 
              className="sqs-bar-fill" 
              style={{ 
                width: `${health}%`, 
                background: health > 50 ? 'linear-gradient(90deg, #55efc4, #81ecec)' : 'linear-gradient(90deg, #ff7675, #fab1a0)' 
              }}
            ></div>
          </div>
        </div>
        <div className="sqs-friction">
          Primary Friction Point: <span style={{ color: '#d63031', fontWeight: '800', background: '#fff5f5', padding: '5px 10px', borderRadius: '8px' }}>
            #{data.friction_point}
          </span>
        </div>
      </div>

      <div className="sqs-grid">
        <div className="sqs-card pos">
          <span>✅ Positive</span>
          <div className="value" style={{ color: '#27ae60' }}>{data.stats.positive}</div>
        </div>
        <div className="sqs-card neg">
          <span>⚠️ Negative</span>
          <div className="value" style={{ color: '#e74c3c' }}>{data.stats.negative}</div>
        </div>
        <div className="sqs-card util">
          <span>💡 Utility</span>
          <div className="value" style={{ color: '#3498db' }}>{data.stats.utility}</div>
        </div>
      </div>

      <div className="sqs-topics">
        <h3 style={{ letterSpacing: '1px' }}>TOP 10 COMMUNITY TOPICS</h3>
        <div className="sqs-tag-container">
          {data.tags.map((tag, index) => (
            <div key={index} className="sqs-tag">#{tag}</div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default App;